var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"app-form",class:[
        _vm.labelPosition ? 'app-form--label-' + _vm.labelPosition : '',
        { 'app-form--inline': _vm.inline }
    ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }